export default {
    title: 'Redirects',
    list: 'Redirects',
    help: 'Old addresses on this website and where they go now. Add one for every URL of an old site that no longer exists, so links and search results land on the right page instead of a 404.',
    empty: 'No redirects yet.',
    new: 'New redirect',
    create: 'Add redirect',
    noTarget: 'no target',
    inactive: 'not followed: its page is deleted or unpublished',
    status: {
        permanent: '301 permanent',
        temporary: '302 temporary',
    },
    form: {
        source: 'Old path',
        sourceHint: 'A path like /about-us/, or paste the full old URL.',
        status: 'Type',
        page: 'Goes to page',
        noPage: 'Another address…',
        url: 'Goes to address',
        urlHint: 'A path on this site (/contact) or a full URL (https://…).',
    },
    created: 'Redirect added.',
    saved: 'Redirect saved.',
    deleted: 'Redirect removed.',
    confirmDelete: 'Remove the redirect for {path}? That address will show a 404 again.',
    loadFailed: 'Could not load the redirects.',
    createFailed: 'Could not add the redirect.',
    saveFailed: 'Could not save the redirect.',
    deleteFailed: 'Could not remove the redirect.',
};
